import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import App from "./App";
import { msalConfig } from "./auth/msalConfig";
// Import global styles
// Suppress browser extension errors (e.g., MetaMask trying to detect dApps)
const originalError = console.error;
console.error = (...args: any[]) => {
  if (
    args[0]?.toString().includes("MetaMask") ||
    args[0]?.toString().includes("message port closed")
  ) {
    return;
  }
  originalError(...args);
};

// Create MSAL instance
let msalInstance: PublicClientApplication;
try {
  msalInstance = new PublicClientApplication(msalConfig);
} catch (error) {
  console.warn("[MSAL] Failed to create instance:", error);
  // Fallback - create with minimal config
  msalInstance = new PublicClientApplication({
    auth: { clientId: "default-client-id" }
  });
}

// Initialize MSAL asynchronously before rendering the app
const initializeAndRender = async () => {
  try {
    await msalInstance.initialize();
  } catch (error) {
    console.warn("[MSAL] Initialization error:", error);
  }

  // Render the app after MSAL is initialized
  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
  );

  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MsalProvider>
    </React.StrictMode>
  );
};

// Start initialization and rendering
initializeAndRender();
